export const BROADCAST_STATUS_LIST = new Map([
  [10, { value: 10, title: 'Scheduled', className: 'status-scheduled' }],
  [15, { value: 15, title: 'Pending', className: 'status-in-progress' }],
  [20, { value: 20, title: 'Completed', className: 'status-completed' }],
  [25, { value: 25, title: 'Completed', className: 'status-completed' }]
])

export const BROADCAST_GRID_SORT_DEFAULT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'descend'
}

export const BROADCAST_GRID_REMOVE_FIELD_LIST = [
  'category',
  'messageSearch',
  'messageVariant',
  'messageLanguage',
  'now'
]

export const BROADCAST_LIBRARY_DEFAULT_SORT = {
  sortedColumn: 'lastUsedDate',
  sortedColumnOrder: 'descend'
}

export const BROADCAST_DATE_TYPE_LIST = [
  { key: 0, value: 'now', title: 'Send message now' },
  { key: 1, value: 'date', title: 'Send message on date' }
]

export const BROADCAST_CAREGIVER_SEND_TYPE_LIST = [
  { key: 0, value: 1, title: 'No recipients' },
  { key: 1, value: 2, title: 'Only primary' },
  { key: 2, value: 3, title: 'All assigned caregivers' }
]
